module.exports = __webpack_public_path__ + "static/img/pad-lock.c6cc6f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pad-lock.svg
// module id = iKka
// module chunks = 1